import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VMEAdditionalCharge } from 'src/app/interfaces/screen-specific/job-screen';

@Component({
  selector: 'app-vme-expense-validation-result',
  templateUrl: './vme-expense-validation-result.component.html',
  styleUrls: ['./vme-expense-validation-result.component.scss'],
})
export class VmeExpenseValidationResultComponent implements OnInit {
  @Input() showValidationResult: boolean = false;
  @Output() showValidationResultChange = new EventEmitter<boolean>();
  @Input() organisationTypeId!: number;
  @Input() selectedAdditionalCharge!: VMEAdditionalCharge;
  @Input() formatChargingWaitingDuration!: (duration: any) => string;

  constructor() {}

  ngOnInit(): void {}
}
